<template>
 <div class="collection-info-section" :class="{'--open': isOpen}">
   <div class="collection-info-section__head" @click="changeOpen">
     <span class="h5 semibold">Срок доставки</span>
     <img src="~/assets/img/svg/common/arrow-down.svg" alt=""/>
   </div>
   <div
     v-html="message"
     class="collection-info-section__body h5"
     :class="{'collection-info-section__body_decoration': getCharFromRedactor(fullStockMessageCharacteristic)}"
   />
 </div>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue';
import { appConfigStore as useAppConfigStore } from '#sitis/stores/modules/app-store';
import { getCharacteristicFromFull } from '~/utils/getCharacteristic';
import getCharFromRedactor from '~/utils/getCharFromRedactor'

const props = defineProps({
  product: {
    type: Object as any
  }
});
const appConfigStore = useAppConfigStore();

const isOpen = ref(true);
const changeOpen = () => {
  isOpen.value = !isOpen.value;
};

const message = computed(() => {
  const inStockProductStatus = getCharacteristicFromFull((props.product?.characteristics || []), 'in_stock_product_status');
  const title = inStockProductStatus?.values?.[0]?.value || appConfigStore?.$state?.vars?.['Товар информация по доставке (заголовок)'];
  return [
    title,
    appConfigStore?.$state?.vars?.['Товар информация по доставке (сообщение)'],
  ].join("<br/>")
})
const fullStockMessageCharacteristic = computed(()=> {
  return getCharacteristicFromFull((props.product?.characteristics || []), 'in_stock_product_status');
})
</script>

<style lang="scss" scoped>
.collection-delivery-term-message {

}
</style>

<style>
.collection-info-section__body_decoration {
  a {
    text-decoration: underline;
    &:hover {
      text-decoration: none;
    }
  }
}
</style>
